const C = require("../constants");

const productRecipesDialog = (data) => {
    return {
        type: C.PRODUCT_RECIPES_DIALOG,
        data
    }
};

export {productRecipesDialog};


// WEBPACK FOOTER //
// ./src/actions/ProductRecipesDialogActions.js